<div class="form-group">
  <label for="exampleFormControlSelect1">Select Vehicle  <i class="material-icons"
      style="color: red;font-size: 14px;">star</i></label>
  <select class="form-control dropdown_box" [(ngModel)]="vehicle_id">
      <option *ngFor="let vehicle of vehicles" [value]="vehicle['id']">{{vehicle['name']}} - {{vehicle['licence_number']}} - {{vehicle['vehicle_type_name'] }}
      </option>
  </select>
  <button mat-raised-button  (click)="changeVehicle()" style="margin-top: 25px;background: #a01ba0;color: aliceblue;">Submit</button>
</div>
 